import { Typography } from '@navi/web-ui/lib/primitives';
import React, { useState } from 'react';
import styles from './index.module.scss';
import DateTimePickerComponent from '@cp/src/components/DateTimePicker/DateTimePickerComponent';
import { DATE_TIME_TYPE } from '@cp/src/components/DateTimePicker/constants';
import { DateFormat, dateFormat } from '@cp/src/utils/DateHelper';
import ForeclosureDetails from './ForeclosureDetails';
import { getForeclosureAmount } from '../../actions/paymentsActions';
import { useParams } from 'react-router-dom';

const FutureForeClosureModal = () => {
  const { loanId = '' } = useParams();
  const [foreclosureDetails, setForeclosureDetails] = useState({
    open: false,
    loading: false,
    date: '',
    data: null
  });

  const updateDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setForeclosureDetails(prevState => ({
      ...prevState,
      date: event?.target?.value,
      loading: true
    }));
    getForeclosureAmount(loanId, event?.target?.value)
      .then(res => {
        setForeclosureDetails(prevState => ({ ...prevState, data: res?.data }));
      })
      .finally(() => setForeclosureDetails(prevState => ({ ...prevState, loading: false })));
  };

  return (
    <div className={styles.foreclosureCard}>
      <Typography color="var(--grayscale-2)" variant="p4">
        Select payment date
      </Typography>
      <DateTimePickerComponent
        type={DATE_TIME_TYPE.DATE}
        min={dateFormat(new Date(), DateFormat.ISO_DATE_FORMAT)}
        value={foreclosureDetails?.date}
        containerClasses={styles.foreclosureDatePicker}
        inputClasses={styles.foreclosureDatePickerInput}
        onChange={updateDate}
        disabled={foreclosureDetails?.loading}
        iconColor="var(--navi-color-blue-base)"
      />
      <ForeclosureDetails
        foreclosureAmount={foreclosureDetails?.data}
        isLoading={foreclosureDetails?.loading}
        containerClass="mt-[-10px] pt-4"
      />
    </div>
  );
};

export default FutureForeClosureModal;
